import { UniversityStudyRoomTemplate } from "@/components/UniversityStudyRoomTemplate";

const UniversityOfIllinois = () => {
  return (
    <UniversityStudyRoomTemplate
      universityName="University of Illinois Urbana-Champaign"
      universityShortName="UIUC"
      slug="university-of-illinois"
      seoTitle="UIUC Study Rooms | University of Illinois Library Study Spaces"
      seoDescription="Find study rooms at UIUC including Grainger Library and Main Library. Learn booking policies and discover CSW as an online alternative."
      seoKeywords="UIUC study rooms, University of Illinois library, Urbana-Champaign study spaces, Illini study rooms, Grainger Library"
      canonicalUrl="/study-room/university-of-illinois/"
      heroDescription="Discover UIUC's extensive library system with rooms across multiple specialized branches."
      libraryWebsiteUrl="https://www.library.illinois.edu"
      libraryWebsiteName="UIUC Libraries"
      studySpaces={[
        {
          name: "Chemistry Library - Room 124C",
          features: "Up to 2 hours, @illinois.edu email required for booking.",
          feedback: "Specialized space for chemistry students. Quick reservations."
        },
        {
          name: "Grainger Library",
          features: "Engineering-focused, group rooms fill quickly.",
          feedback: "Popular with STEM students. Some noise complaints on quiet floors."
        },
        {
          name: "Main Library - Stacks",
          features: "Quiet carrels for individual study, deep in the stacks.",
          feedback: "Ultimate quiet study. Can feel isolated but very peaceful."
        },
        {
          name: "Music & Performing Arts Library",
          features: "Second-floor reading room, unique atmosphere.",
          feedback: "Beautiful space for creative work. Less crowded."
        }
      ]}
      guideContent={
        <>
          <p>
            UIUC libraries have numerous group study rooms; for example, Chemistry Library's Room 124C can be reserved 
            for up to two hours and requires an @illinois.edu email address. Many rooms follow similar two-hour limits.
          </p>
          <p className="mt-4">
            Students often find that group rooms in Grainger and other libraries fill quickly, and some complain about 
            noise on designated quiet floors. Because room-specific policies are scattered, students can be confused about booking.
          </p>
          <p className="mt-4">
            Use the unified LibCal site to find and reserve rooms. For quiet study, head to the quiet carrels in the 
            Main Library stacks or the second-floor reading room at the Music & Performing Arts Library. 
            Consider off-peak times (early morning or late evening) to secure a group room.
          </p>
        </>
      }
      summaryTips={[
        "Use LibCal site for unified room booking",
        "Most rooms have 2-hour limits",
        "Main Library stacks offer deep quiet study",
        "Grainger fills quickly during peak hours",
        "Early morning and late evening are best times"
      ]}
    />
  );
};

export default UniversityOfIllinois;
